/*@flow*/
import * as t from 'lib/t';
import Section from './templates/Section';
import AsyncTemplate from './templates/AsyncTemplate';
import * as loaders from 'queries/loaders';
import DateRangeStructTemplate from './templates/DateRangeStructTemplate';
import TagsTemplate from './templates/Tags';

const config = {
  category: t.enums({}).options({
    legend: 'Categories',
    nullOption: false,
    className: 'tenant-event-categories-select-field',
    loadValues: (o) => loaders.eventCategoryLoader(o),
    placeholder: 'Select categories',
    template: AsyncTemplate,
  }),
  date: t
    .struct({
      startsAt: t.Date,
      endsAt: t.Date,
    })
    .opt({
      label: 'Time & Date',
      template: DateRangeStructTemplate,
    }),
  tags: t.list(t.String).opt({
    label: 'Tags',
    template: TagsTemplate,
    filterName: 'events',
  }),
};

export default t.struct(config).opt<any>({
  label: 'Events',
  iconClass: 'fa-calendar',
  template: Section,
});
